/*
  Collection and search filters without page reloads.

  The section root carries [data-facets] and data-section-id. Every filter change
  (option links, Clear, price slider / boxes, page numbers) fetches the same URL
  through Shopify's Section Rendering API (?section_id=...) and swaps only the
  [data-facets-part] regions, so the page never reloads or jumps. Open filter
  groups, the filter panel's scroll and the focused control are kept. The address
  bar follows each change, so Back/Forward and shared links work. Any failure
  falls back to a normal page load of the same URL.

  Also owns the price box formatting, the two-handle price slider and the
  page-only "Part type" buttons, since scripts inside swapped HTML never run.
*/
(function () {
  var root = document.querySelector('[data-facets]');
  if (!root) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pending = null;
  var applyTimer = null;

  // ---------- price boxes and slider ----------
  function money(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function formatPrice(raw) {
    var digits = String(raw).replace(/[^\d.]/g, '');
    var parts = digits.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.length > 1 ? whole + '.' + parts[1].slice(0, 2) : whole;
  }
  function num(s) { var v = parseFloat(String(s).replace(/[^\d.]/g, '')); return isNaN(v) ? null : v; }

  function sliderParts(box) {
    var form = box.closest('form');
    return {
      form: form,
      lo: box.querySelector('[data-price-thumb="min"]'),
      hi: box.querySelector('[data-price-thumb="max"]'),
      fill: box.querySelector('[data-price-fill]'),
      fields: form.querySelectorAll('[data-price-input]'),
      top: +box.dataset.top
    };
  }
  function paint(box) {
    var s = sliderParts(box);
    s.fill.style.left = (s.lo.value / s.top * 100) + '%';
    s.fill.style.right = (100 - s.hi.value / s.top * 100) + '%';
    // When both handles sit at the top end, keep the min handle grabbable.
    s.lo.style.zIndex = +s.lo.value > s.top - s.top / 20 ? 3 : 2;
    s.lo.setAttribute('aria-valuetext', '$' + money(s.lo.value));
    s.hi.setAttribute('aria-valuetext', +s.hi.value >= s.top ? 'No maximum' : '$' + money(s.hi.value));
  }
  function sliderToFields(box, moved) {
    var s = sliderParts(box);
    var a = +s.lo.value, b = +s.hi.value;
    if (a > b) { if (moved === s.lo) s.lo.value = a = b; else s.hi.value = b = a; }
    // The handles already move in tidy steps (step attribute), so the box shows exactly the handle.
    s.fields[0].value = a <= 0 ? '' : money(a);
    s.fields[1].value = b >= s.top ? '' : money(b);
    paint(box);
  }
  function fieldsToSlider(box) {
    var s = sliderParts(box);
    var a = num(s.fields[0].value), b = num(s.fields[1].value);
    s.lo.value = a == null ? 0 : Math.min(a, s.top);
    s.hi.value = b == null ? s.top : Math.min(b, s.top);
    paint(box);
  }

  // The search page's backup price slider (drawn when Shopify leaves Price out) can't know
  // the current limits server-side, so they come from the address.
  function fillFallback(scope, params) {
    scope.querySelectorAll('[data-price-fallback]').forEach(function (form) {
      var box = form.querySelector('[data-price-slider]');
      var any = false;
      form.querySelectorAll('[data-price-input]').forEach(function (f) {
        var v = params.get(f.name) || '';
        f.value = v;
        if (v) any = true;
        // A limit past the slider's top stretches it so the handle can still show it.
        var n = num(v);
        if (box && n != null && n > +box.dataset.top) {
          var unit = +box.dataset.unit || 1;
          var top = Math.ceil(n / unit) * unit;
          box.dataset.top = top;
          box.querySelectorAll('[data-price-thumb]').forEach(function (r) { r.max = top; });
        }
      });
      if (box) fieldsToSlider(box);
      if (any) { var d = form.closest('details'); if (d) d.open = true; }
    });
  }

  function setup(scope) {
    scope.querySelectorAll('[data-price-input]').forEach(function (input) {
      if (input.value) input.value = formatPrice(input.value);
    });
    scope.querySelectorAll('[data-price-slider]').forEach(function (box) {
      box.hidden = false;
      paint(box);
    });
  }

  root.addEventListener('input', function (e) {
    var t = e.target;
    if (t.matches('[data-price-thumb]')) { sliderToFields(t.closest('[data-price-slider]'), t); return; }
    if (t.matches('[data-price-input]')) {
      t.value = formatPrice(t.value);
      var box = t.form && t.form.querySelector('[data-price-slider]');
      if (box) fieldsToSlider(box);
    }
  });
  // Letting go of a handle applies it; a short pause so arrow-key nudges batch up.
  root.addEventListener('change', function (e) {
    if (!e.target.matches('[data-price-thumb]')) return;
    var form = e.target.form || e.target.closest('form');
    clearTimeout(applyTimer);
    applyTimer = setTimeout(function () { go(formUrl(form)); }, 250);
  });
  root.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-price-facet]')) return;
    e.preventDefault();
    clearTimeout(applyTimer);
    go(formUrl(form));
  });

  // Start from the address bar (the filters that are really on now), drop the page
  // number and swap in the two price limits. Empty box = no limit.
  function formUrl(form) {
    var params = new URLSearchParams(location.search);
    params.delete('page');
    form.querySelectorAll('[data-price-input]').forEach(function (f) {
      params.delete(f.name);
      var v = f.value.replace(/,/g, '').trim();
      if (v !== '') params.set(f.name, v);
    });
    var action = form.getAttribute('action') || location.pathname;
    var q = params.toString();
    return action + (q ? '?' + q : '');
  }

  // ---------- links: filter options, Clear, page numbers ----------
  root.addEventListener('click', function (e) {
    // Page-only "Part type" buttons filter the cards already on screen.
    var typeBtn = e.target.closest('.type-filter');
    if (typeBtn) {
      var facet = typeBtn.closest('[data-type-facet]');
      facet.querySelectorAll('.type-filter').forEach(function (b) { b.setAttribute('aria-pressed', b === typeBtn ? 'true' : 'false'); });
      var value = typeBtn.getAttribute('data-type-value');
      root.querySelectorAll('[data-product-grid] > li').forEach(function (li) {
        li.hidden = value !== '' && li.getAttribute('data-type') !== value;
      });
      return;
    }
    var a = e.target.closest('a[href]');
    if (!a || !root.contains(a) || !a.closest('.filters, .pagination, .empty, [data-facets-link]')) return;
    // Part type links on big collections open another collection: a normal page load.
    if (a.hasAttribute('data-full-load')) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || a.target === '_blank') return;
    var url = new URL(a.href, location.href);
    if (url.origin !== location.origin) return;
    e.preventDefault();
    go(url.pathname + url.search, { toResults: !!a.closest('.pagination') });
  });

  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.facets) go(location.pathname + location.search, { push: false });
  });
  try { history.replaceState({ facets: true }, '', location.href); } catch (err) {}

  // ---------- fetch and swap ----------
  function go(url, opts) {
    opts = opts || {};
    var target = new URL(url, location.href);
    target.searchParams.delete('section_id');
    var fetchUrl = new URL(target.href);
    fetchUrl.searchParams.set('section_id', root.dataset.sectionId);

    if (pending) pending.abort();
    var ctrl = window.AbortController ? new AbortController() : null;
    pending = ctrl;
    root.classList.add('is-loading');
    root.setAttribute('aria-busy', 'true');

    fetch(fetchUrl.href, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        if (pending !== ctrl) return;
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-facets]');
        if (!fresh) throw new Error('no filter markup');
        swap(fresh, target);
        if (opts.push !== false) history.pushState({ facets: true }, '', target.pathname + target.search);
        if (opts.toResults) toResults();
        done(ctrl);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        location.assign(target.href);
      });
  }
  function done(ctrl) {
    if (pending !== ctrl) return;
    pending = null;
    root.classList.remove('is-loading');
    root.removeAttribute('aria-busy');
  }

  function swap(fresh, target) {
    var open = {};
    root.querySelectorAll('details[data-facet-key]').forEach(function (d) { open[d.dataset.facetKey] = d.open; });
    var panel = root.querySelector('.filters__panel');
    var panelScroll = panel ? panel.scrollTop : 0;
    var active = document.activeElement;
    var focusKey = active && root.contains(active) ? active.getAttribute('data-focus-key') : null;
    // Shopify's search sometimes leaves the Price filter out of a reply (collections don't).
    // Keep the one on screen so it can't vanish mid-use; the price limit still applies.
    var priceGroup = null, priceIndex = -1;
    var oldPrice = root.querySelector('[data-price-facet]');
    if (oldPrice && !fresh.querySelector('[data-price-facet]')) {
      priceGroup = oldPrice.closest('details');
      priceIndex = Array.prototype.indexOf.call(priceGroup.parentNode.children, priceGroup);
    }

    root.querySelectorAll('[data-facets-part]').forEach(function (part) {
      var next = fresh.querySelector('[data-facets-part="' + part.dataset.facetsPart + '"]');
      if (next) part.innerHTML = next.innerHTML;
    });

    if (priceGroup) {
      var holder = root.querySelector('.filters__panel > div') || root.querySelector('.filters__panel');
      if (holder) {
        holder.insertBefore(priceGroup, holder.children[priceIndex] || null);
        // Match the kept filter to the new address (e.g. after Clear it must read empty).
        var params = target.searchParams;
        priceGroup.querySelectorAll('[data-price-input]').forEach(function (f) { f.value = params.get(f.name) || ''; });
        var keptBox = priceGroup.querySelector('[data-price-slider]');
        if (keptBox) fieldsToSlider(keptBox);
      }
    }

    fillFallback(root, target.searchParams);

    root.querySelectorAll('details[data-facet-key]').forEach(function (d) {
      if (Object.prototype.hasOwnProperty.call(open, d.dataset.facetKey)) d.open = open[d.dataset.facetKey];
    });
    panel = root.querySelector('.filters__panel');
    if (panel) panel.scrollTop = panelScroll;

    // New cards: show them straight away (no scroll-reveal) and wire the image fade.
    root.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
    if (window.wireImgFade) window.wireImgFade(root);
    setup(root);

    if (focusKey) {
      var again = root.querySelector('[data-focus-key="' + (window.CSS && CSS.escape ? CSS.escape(focusKey) : focusKey) + '"]');
      if (again) again.focus({ preventScroll: true });
    }
    var status = root.querySelector('[data-facets-status]');
    var count = root.querySelector('[data-facets-count]');
    if (status && count) status.textContent = count.textContent.trim();
  }

  function toResults() {
    var results = root.querySelector('[data-facets-part="body"]');
    if (!results) return;
    var y = results.getBoundingClientRect().top + window.pageYOffset - 96;
    window.scrollTo({ top: Math.max(0, y), behavior: reduceMotion ? 'auto' : 'smooth' });
    results.setAttribute('tabindex', '-1');
    results.focus({ preventScroll: true });
  }

  fillFallback(root, new URLSearchParams(location.search));
  setup(root);
})();
